<ion-button (click)="toggleChange()" fill="clear">
  @if (paletteToggle()) {
    <ion-icon
      name="sunny-outline"
      aria-label="Activer le thème clair"
      color="dark"
      slot="icon-only"
    />
  } @else {
    <ion-icon
      name="moon"
      aria-label="Activer le thème sombre"
      color="dark"
      slot="icon-only"
    />
  }
</ion-button>
